module.exports = __webpack_public_path__ + "img/yj_applet_alert.8e3e3324.png";